import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';

import styled from 'styled-components';

interface GenericSpinnerProps {
    style?: React.CSSProperties;
    size?: string | number;
}

const GenericSpinner: React.FC<React.PropsWithChildren<GenericSpinnerProps>> =
    ({ style, size }) => {
        return (
            <Container>
                <CircularProgress style={{ ...style }} size={size} />
            </Container>
        );
    };

const Container = styled.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    width: '100%',
    minHeight: '100%',
});

export default GenericSpinner;
